// extracted by mini-css-extract-plugin
export default {"Circle4":"Circle4_Circle4__pXSXV"};